import { Component, OnDestroy, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { StationLongDto } from '@api/rest';
import { ContentFacade } from '@app/content/content.facade';
import { AppService } from '@app/core/services/app.service';
import { TemplateDownloadService } from '@app/core/services/template-download.service';
import { StationType } from '@app/shared/enums/station-type.enum';
import { Template } from '@app/shared/models/template';
import { StationFacade } from '@app/station/station.facade';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';

import { MatAnchor } from '@angular/material/button';

@Component({
    selector: 'app-templates',
    templateUrl: './templates.component.html',
    styleUrls: ['./templates.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatAnchor]
})
export class TemplatesComponent implements OnInit, OnDestroy {
  private readonly facade = inject(StationFacade);
  private readonly translate = inject(TranslateService);
  private readonly appService = inject(AppService);
  private readonly contentFacade = inject(ContentFacade);
  private readonly templateDownloadService = inject(TemplateDownloadService);


  public readonly templateStations$: Observable<StationLongDto[]> = this.facade.getStationsByType(StationType.TEMPLATE);
  public templates = signal<Template[]>([]);

  private readonly destroy$: Subject<void> = new Subject<any>();

  ngOnInit(): void {
    this.fillTemplates();
  }

  private fillTemplates() {
    combineLatest([this.templateStations$, this.appService.dynamicContentUrl$])
      .pipe(
        takeUntil(this.destroy$)
      ).subscribe(
        ([stations, dynamicContentUrl]) => {
          const tempTemplates = [];
          for (const station of stations) {
            this.contentFacade.getContentById(station.content_refs.find(() => true))
              .pipe(
                takeUntil(this.destroy$)
              ).subscribe(content => {
                const href =  content?.files?.find(() => true).href;
                if (href) {
                  tempTemplates.push({
                    title: station.title[this.translate.getCurrentLang()],
                    url: dynamicContentUrl
                      + content?.files?.find(() => true).href,
                    selected: false,
                    filename: content?.files?.find(() => true).filename
                  });
                }
              });
            }
            this.templates.set(tempTemplates);
          }
      )
  }

  openTemplate(event: MouseEvent, template: Template) {
    event.preventDefault();
    this.templateDownloadService.download(template.url, template.filename);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
